class CollectionTabs extends HTMLElement {
  constructor() {
    super();
    this.tabButtons = this.querySelectorAll('.collection-tabs__nav-button');
    this.tabPanels = this.querySelectorAll('.collection-tabs__panel');
    this.init();
  }

  init() {
    if (this.tabButtons.length === 0 || this.tabPanels.length === 0) return;

    // 各タブボタンにイベントリスナーを追加
    this.tabButtons.forEach((button, index) => {
      button.addEventListener('click', () => this.switchTab(index));
      button.addEventListener('keydown', (e) => this.handleKeydown(e, index));
    });
  }

  switchTab(index) {
    const targetButton = this.tabButtons[index];
    const targetPanel = this.tabPanels[index];

    if (!targetButton || !targetPanel) return;

    // すべてのタブとパネルを非アクティブにする
    this.tabButtons.forEach((btn) => {
      btn.classList.remove('collection-tabs__nav-button--active');
      btn.setAttribute('aria-selected', 'false');
    });

    this.tabPanels.forEach((panel) => {
      panel.classList.remove('collection-tabs__panel--active');
      panel.setAttribute('hidden', '');
    });

    // 選択されたタブとパネルをアクティブにする
    targetButton.classList.add('collection-tabs__nav-button--active');
    targetButton.setAttribute('aria-selected', 'true');
    targetPanel.classList.add('collection-tabs__panel--active');
    targetPanel.removeAttribute('hidden');

    // フォーカスを設定
    targetButton.focus();
  }

  handleKeydown(event, currentIndex) {
    let targetIndex = currentIndex;

    switch (event.key) {
      case 'ArrowLeft':
        event.preventDefault();
        targetIndex = currentIndex > 0 ? currentIndex - 1 : this.tabButtons.length - 1;
        this.switchTab(targetIndex);
        break;
      case 'ArrowRight':
        event.preventDefault();
        targetIndex = currentIndex < this.tabButtons.length - 1 ? currentIndex + 1 : 0;
        this.switchTab(targetIndex);
        break;
      case 'Home':
        event.preventDefault();
        this.switchTab(0);
        break;
      case 'End':
        event.preventDefault();
        this.switchTab(this.tabButtons.length - 1);
        break;
    }
  }
}

if (!customElements.get('collection-tabs')) {
  customElements.define('collection-tabs', CollectionTabs);
}
